export enum EStempButtonStatus {
  START_WORK_RECORD,
  STOP_WORK_RECORD,
  DISABLED,
}
